import { render, staticRenderFns } from "./NbProductCard.vue?vue&type=template&id=6bffd764&scoped=true&"
import script from "./NbProductCard.vue?vue&type=script&lang=js&"
export * from "./NbProductCard.vue?vue&type=script&lang=js&"
import style0 from "./NbProductCard.vue?vue&type=style&index=0&id=6bffd764&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bffd764",
  null
  
)

export default component.exports